import type { IconData } from './icon-data';
import { ICON_LOADERS } from './icon-loaders';
import type { IconName } from './icon-name';

const loads = new Map<IconName, Promise<IconData>>();

export function getIconNames(): IconName[] {
  return Object.keys(ICON_LOADERS) as IconName[];
}

export function loadIcon(name: IconName): Promise<IconData> {
  if (!isIconName(name)) return Promise.reject(new Error(`Unknown icon: ${name}`));
  let pending = loads.get(name);
  if (!pending) {
    pending = ICON_LOADERS[name]()
      .then(module => module.icon)
      .catch(cause => {
        loads.delete(name);
        throw new Error(`Unable to load icon: ${name}`, { cause });
      });
    loads.set(name, pending);
  }
  return pending;
}

export function isIconName(value: string): value is IconName {
  return Object.hasOwn(ICON_LOADERS, value);
}
